// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__3OEZ8","requiredAsterisk":"Info_requiredAsterisk__1BFOJ"};